import Lottie from 'lottie-react';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Card, CardBody, Col, Row} from 'reactstrap';
import {reportingApi} from '../../../../api';
import {Block} from '../../../../components/block/Block';
import noFilesIcon from '../../../../shared/icons/noFilesIcon.json';
import {IPicture} from '../../../../shared/interfaces/Picture';
import ReportingFileTable from '../../../reporting/components/ReportingFileTable';
import ChangeStep from './ChangeStep';
import {IStepperProps} from './index';

const CampaignStep4 = ({campaignData}: IStepperProps) => {
  const {t} = useTranslation();
  const [fileList, setFileList] = useState<IPicture[]>([]);
  const getReportings = async (campaignId: string) => {
    const {
      data: {reports: data},
    } = await reportingApi.getAllReportings(campaignId);
    setFileList(data);
  };

  useEffect(() => {
    if (!!campaignData?.id) {
      getReportings(String(campaignData?.id));
    }
  }, [campaignData?.id]);
  return (
    <Block size="lg" className="mt-3">
      <ChangeStep
        currentCampaignStep={campaignData?.currentStep}
        status={campaignData?.status}
        campaignId={campaignData?.id}
        activeStep={6}
        name={campaignData?.name}
      />
      <Card className="card-bordered card-preview">
        <CardBody>
          <Row>
            <Col md={12}>
              {!!fileList?.length ? (
                <ReportingFileTable fileList={fileList} />
              ) : (
                <div className="my-5 center-items-flex flex-column">
                  <Lottie animationData={noFilesIcon} loop={true} style={{width: 300}} />
                  <h5>No reportings</h5>
                  <p className="text-muted">{t('campaigns.noReportingsDesc')}</p>
                </div>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Block>
  );
};

export default CampaignStep4;
